<script>
  import  { DirectionalLight } from 'three'
  import { renderable } from './three-viz.js'

  export let color
  export let position
  export let castShadow

  renderable({
    setup: props => {
      const { scene, renderer } = props

      const light = new DirectionalLight(color, 1)

      light.position.set(position[0], position[1], position[2])
      light.castShadow = castShadow
      if (castShadow) {
        light.shadow.mapSize.width = 1024
        light.shadow.mapSize.height = 1024
        light.shadow.camera.near = 1
        light.shadow.camera.far = 100
        renderer.shadowMap.enabled = true
      }

      scene.add(light)

    },
  })
</script>
